import { supabase } from '@/integrations/supabase/client';

export type PaymentMethod = 'online' | 'pay_on_delivery';

export interface PayOnDeliveryPayload {
  items: Array<{ productId: string; quantity: number }>;
  delivery_fee: number;
  delivery_type: 'fez' | 'self';
  recipient_name: string;
  recipient_phone: string;
  delivery_address_line: string;
  delivery_city: string;
  delivery_state: string;
  email?: string;
}

export async function placePayOnDeliveryOrder(payload: PayOnDeliveryPayload) {
  const { data, error } = await supabase.functions.invoke('create-cod-order', { body: payload });
  if (error) {
    let msg = error.message;
    try {
      const ctx = await (error as any).context?.json?.();
      if (ctx?.error) msg = ctx.error;
    } catch { /* ignore */ }
    throw new Error(data?.error || msg || 'Could not place your order');
  }
  if (!data?.status || !data?.orderId) throw new Error(data?.error || 'Could not place your order');
  return data as { status: true; orderId: string; orderIds: string[]; total: number };
}
